import { Link } from 'react-router-dom';
import LuxReveal from './LuxReveal';

export default function LuxCta({ eyebrow = 'Limited seats', title, highlight, primary = { to: '/admission', label: 'Apply — Free' }, secondary }) {
  return (
    <section className="lux-cta-full">
      <LuxReveal>
        <p className="lux-statement__eyebrow">{eyebrow}</p>
        <h2>
          {title}
          {highlight && (
            <>
              <br />
              <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>{highlight}</em>
            </>
          )}
        </h2>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginTop: 8 }}>
          <Link to={primary.to} className="btn-lux btn-lux--fill" style={{ color: '#030712' }}>{primary.label}</Link>
          {secondary && (
            <Link to={secondary.to} className="btn-lux btn-lux--line" style={{ color: 'var(--text)', borderColor: 'var(--border)' }}>
              {secondary.label}
            </Link>
          )}
        </div>
      </LuxReveal>
    </section>
  );
}
